import { fromJS, Map } from 'immutable';

export function request(state, action) {
    let collections = state.get('collections');

    collections = collections.set(action.id, fromJS({
        state: 'IN_PROGRESS',
        items: []
    }));
    return state.set('collections', collections);
}

export function error(state, action) {
    let collections = state.get('collections');

    collections = collections.set(action.id, fromJS({
        state: 'ERROR',
        errors: action.errors
    }));

    return state.set('collections', collections);
}

export function finish(state, action) {
    let collections = state.get('collections');

    collections = collections.set(action.id, fromJS({
        state: 'FINISHED',
        items: action.selections.map((selection) => selection.id)
    }));

    return state.set('collections', collections);
}
